import OrderProduct from 'components/OrderProduct';

const PageOrderElectric = () => {
    return (
        <div className="container mx-auto p-6">
            <OrderProduct category_id={2} description='If you require other electrical equipment or services not listed in this catalogue, please contact us and we will be happy to advise'/>
        </div>
    );
};

export default PageOrderElectric;
